import React from "react";

import styled from "styled-components/macro";

import { useNetworkMetadata } from "Flocknote/apiHooks";

import NavLink, { typographyProps } from "NavBar/components/NavLink";

import FnrNetworkPhoto from "UI/FnrNetworkPhoto";
import FnrTypography from "UI/FnrTypography";

function ParentNetLink() {
  const [{ parentNetworkInfo }] = useNetworkMetadata();
  const { name, shortname, photoUrl } = parentNetworkInfo || {};
  const hasParentNet = Boolean(name && shortname && photoUrl);

  const baseUrl = window.location.host.split(".").slice(1).join(".");
  const link = `https://${shortname}.${baseUrl}`;

  if (!hasParentNet) return null;

  return (
    <CenteredWrapper>
      <SNavLink
        to={link}
        external
        data-cy={`NavBar_ParentNetwork_${shortname}`}
        borderRadius={8}
        paddingX={12}
        paddingY={4}
        targetBlank
      >
        <NetworkWrapper>
          <FnrNetworkPhoto noBorder size="xs" shape="circle" src={photoUrl} />
          <FnrTypography {...typographyProps} noWrap={false}>
            {name}
          </FnrTypography>
        </NetworkWrapper>
      </SNavLink>
    </CenteredWrapper>
  );
}

const CenteredWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 4px;
`;

const NetworkWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const SNavLink = styled(NavLink)`
  padding-left: 8px;
`;

export default ParentNetLink;
